<template>
  <div>
    <!-- <Search /> -->
    <Notice style="margin-bottom: 0;z-index:99" />
    <div class="passport-user-detail">
      <div>
        <div class="num">{{ user.studyCourseNum || 0 }}</div>
        <div>已学课程</div>
      </div>
      <div>
        <div class="num">{{ user.passportName || '-' }}</div>
        <div>护照等级</div>
      </div>
      <div>
        <div class="num">{{ user.integral.toLocaleString('en-US') || 0 }}</div>
        <div>当年学分</div>
      </div>
    </div>
    <PassportMap @handleMonth="handleMonth" :ppn="PPN" />
    <MonthChart v-show="monthShow" :ppn="PPN" :isUser="true" />
  </div>
</template>

<script>
import Notice from '../notice'
import MonthChart from '../monthChart.vue'
import PassportMap from '../passportMap.vue'
import { getUserByPpn } from '@/api/user/index.js'
export default {
  components: { Notice, MonthChart, PassportMap },
  name: 'passport',
  data() {
    return {
      monthShow: true,
      dealerId: '',
      PPN: '',
      user: {
        integral: 0,
      },
    }
  },
  methods: {
    handleMonth(e) {
      this.monthShow = e
    },
    getUser() {
      getUserByPpn({
        ppn: this.PPN,
      }).then((res) => {
        this.user = res.data
        if (res.data.avatar != '') {
          this.avatarImg = res.data.avatar
        }
        res.data.userMapList.forEach((item) => {
          if (item.mapStudy == '1') {
            this.badgeList.push(item.img)
          }
        })
      })
    },
  },
  created() {},
  mounted() {
    // this.dealerId = JSON.parse(localStorage.getItem('user')).dealerId
    if (this.$route.query.id) {
      this.PPN = this.$route.query.id
    } else {
      this.PPN = JSON.parse(localStorage.getItem('user')).ppn
    }
    this.getUser()

    //this.initGroup()
    //this.initMonth()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.passport-user-detail {
  z-index: 9;
  position: relative;
  top: -3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 58px;
  border-radius: 0 0 6px 6px;
  background: #fff;
  margin-bottom: 5px;
  & > div {
    padding: 0 20px;
    font-size: 11px;
    text-align: center;
    color: #353535;
    font-size: 11px;
    font-weight: 400;
    .num {
      font-family: 'Porsche Next';
      font-size: 16px;

      color: #d5001c;
    }
  }
}
</style>
